export default __webpack_public_path__ + "static/media/Rectangle 3453.590979c5.png";